import React from 'react';
import { Text } from './Text';

export const Copyright = ({ ...props }) => (
  <Text color="brownGrey" size="12" {...props}>
    © Copyright ALETHIO All rights reserved.
  </Text>
);
